import {
  UTM_DEFAULT_CAMPAIGN,
  UTM_DEFAULT_MEDIUM,
  UTM_DEFAULT_SOURCE,
  resolveUtmParams,
  sanitizeMarketingUtmSource,
  urlSinUtmsPrincipales,
} from "../utils/utmParams";

export { UTM_DEFAULT_CAMPAIGN, UTM_DEFAULT_MEDIUM, UTM_DEFAULT_SOURCE };

// Configuración de números de WhatsApp por UTM parameters
export const whatsappConfig = {
  default: {
    number: "+543516825130",
    message: "Hola Montironi Ford!",
  },
};

export const getWhatsAppUrl = (utmParams = {}) => {
  const { utm_source } = utmParams;

  if (utm_source && whatsappConfig[utm_source]) {
    const config = whatsappConfig[utm_source];
    const encodedMessage = encodeURIComponent(config.message);
    return `https://api.whatsapp.com/send?phone=${config.number}&text=${encodedMessage}`;
  }

  const defaultConfig = whatsappConfig.default;
  const encodedMessage = encodeURIComponent(defaultConfig.message);
  return `https://api.whatsapp.com/send?phone=${defaultConfig.number}&text=${encodedMessage}`;
};

export const getUtmParams = () => resolveUtmParams();

export const saveUtmParams = () => {
  const query = new URLSearchParams(window.location.search);
  if (!query) return;

  if (urlSinUtmsPrincipales(query)) {
    sessionStorage.setItem("utm_source", UTM_DEFAULT_SOURCE);
    sessionStorage.setItem("utm_medium", UTM_DEFAULT_MEDIUM);
    sessionStorage.setItem("utm_campaign", UTM_DEFAULT_CAMPAIGN);
    sessionStorage.removeItem("utm_term");
    return;
  }

  if (query.has("utm_source")) {
    const src = sanitizeMarketingUtmSource(query.get("utm_source")) ?? UTM_DEFAULT_SOURCE;
    sessionStorage.setItem("utm_source", src);
  }
  if (query.get("utm_medium")) {
    sessionStorage.setItem("utm_medium", query.get("utm_medium"));
  }
  if (query.get("utm_campaign")) {
    sessionStorage.setItem("utm_campaign", query.get("utm_campaign"));
  }
  if (query.get("utm_term")) {
    sessionStorage.setItem("utm_term", query.get("utm_term"));
  }
};

export const getCurrentUrlWithUtmDefaults = () => {
  const currentUrl = new URL(window.location.href);
  const query = currentUrl.searchParams;
  const { utm_source, utm_medium, utm_campaign } = resolveUtmParams();

  if (urlSinUtmsPrincipales(query)) {
    query.set("utm_source", utm_source);
    query.set("utm_medium", utm_medium);
    query.set("utm_campaign", utm_campaign);
    return currentUrl.toString();
  }

  if (!query.get("utm_source")) query.set("utm_source", utm_source);
  if (!query.get("utm_medium")) query.set("utm_medium", utm_medium);
  if (!query.get("utm_campaign")) query.set("utm_campaign", utm_campaign);

  return currentUrl.toString();
};

export const buildUtmQueryString = () => {
  const { utm_source, utm_medium, utm_campaign } = getUtmParams();
  return `?utm_source=${encodeURIComponent(utm_source)}&utm_medium=${encodeURIComponent(
    utm_medium
  )}&utm_campaign=${encodeURIComponent(utm_campaign)}`;
};

// Mantiene los UTMs visibles en la URL al navegar (no usa solo sessionStorage).
export const getNavigationSearch = (searchFromRouter = "") => {
  if (searchFromRouter && searchFromRouter.startsWith("?")) {
    return searchFromRouter;
  }
  if (typeof window !== "undefined" && window.location.search) {
    return window.location.search;
  }
  return buildUtmQueryString();
};

export const buildRouteWithUtms = (pathname, searchFromRouter = "") => ({
  pathname,
  search: getNavigationSearch(searchFromRouter),
});

export const WHATSAPP_CONSULTA_PHONE = "5493513527817";

export const buildWhatsAppConsultaUrl = () => {
  const urlWithUtm = getCurrentUrlWithUtmDefaults();
  const whatsappMessage = `Hola, me gustaría hacer una consulta.\n${urlWithUtm}`;
  const encodedMessage = encodeURIComponent(whatsappMessage);
  return `https://api.whatsapp.com/send?phone=${WHATSAPP_CONSULTA_PHONE}&text=${encodedMessage}`;
};

export const openWhatsAppConsulta = () => {
  const whatsappUrl = buildWhatsAppConsultaUrl();
  const opened = window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  if (!opened) {
    window.location.assign(whatsappUrl);
  }
};
